import React, { useEffect, useState } from "react";
import axios from "axios";
import jobList from "../jobs";

export default function IconPage() {
    const [selectedKey, setSelectedKey] = useState(jobList[0].key);
    const [editValue, setEditValue] = useState("");

    useEffect(() => {
        async function fetchDesc() {
            try {
                const res = await axios.get(`/api/icons/${selectedKey}`);
                setEditValue(res.data);
            } catch (err) {
                setEditValue("");
            }
        }
        fetchDesc();
    }, [selectedKey]);

    const handleSelect = (e) => {
        setSelectedKey(e.target.value);
    };

    const handleChange = (e) => {
        setEditValue(e.target.value);
    };

    const handleSave = async () => {
        try {
            await axios.post("/api/manage/icons", {
                job: selectedKey,
                desc: editValue
            });
            alert("수정되었습니다.");
        } catch (err) {
            alert("저장 실패: " + err.message);
        }
    };

    return (
        <div style={{ maxWidth: 900, margin: "40px auto", fontFamily: "sans-serif" }}>
            <h2 style={{ textAlign: "center", marginBottom: 24 }}>아이콘 설명 수정</h2>
            <div style={{ display: "flex", gap: 24 }}>
                <div style={{ minWidth: 200 }}>
                    <label style={{ fontWeight: 600, marginBottom: 8, display: "block" }}>카테고리 선택</label>
                    <select
                        value={selectedKey}
                        onChange={handleSelect}
                        style={{ width: "100%", padding: 8, borderRadius: 4, border: "1px solid #ccc" }}
                    >
                        {jobList.map((item) => (
                            <option key={item.key} value={item.key}>
                                {item.label}
                            </option>
                        ))}
                    </select>
                </div>
                <div style={{ flex: 1 }}>
                    <label style={{ fontWeight: 600, marginBottom: 8, display: "block" }}>설명</label>
                    <textarea
                        value={editValue}
                        onChange={handleChange}
                        rows={18}
                        style={{ width: "100%", padding: 12, borderRadius: 4, border: "1px solid #ccc", fontFamily: "inherit", fontSize: 15, whiteSpace: "pre-line" }}
                    />
                    <button
                        onClick={handleSave}
                        style={{
                            marginTop: 16,
                            background: "#1677ff",
                            color: "#fff",
                            border: "none",
                            borderRadius: 4,
                            padding: "8px 32px",
                            fontWeight: 600,
                            cursor: "pointer"
                        }}
                    >
                        저장
                    </button>
                </div>
            </div>
        </div>
    );
}